import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";
import { demoConfig } from "./firebaseConfigs/demo";
import { stagingConfig } from "./firebaseConfigs/staging";
import { prodConfig } from "./firebaseConfigs/prod";

const firebaseConfig =
  import.meta.env.MODE === "prod"
    ? prodConfig
    : import.meta.env.MODE === "demo"
      ? demoConfig
      : stagingConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const storage = getStorage(app);
export let messaging: ReturnType<typeof getMessaging> | undefined = undefined;

if (await isSupported()) {
  messaging = getMessaging(app);
}

if (import.meta.env.MODE === "development") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectStorageEmulator(storage, "localhost", 9199);
}
